import React from "react";
import { useTable } from "../../Components/useTable";
const GiftList = () => {
  const type = "Gift";

  const limitPerpage = 100;
  const pageRowslinit = [20, 50, 100];
  const headCells = [
    { id: "name", numeric: false, label: "Name" },
    { id: "type", numeric: false, label: "Type" },
    { id: "diamond", numeric: false, label: "Diamond" },
    { id: "pictureUrl", numeric: false, label: "Picture" },
    { id: "animationUrl", numeric: false, label: "Animation" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default GiftList;
